import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import "./App.css";
import "./responsive.css";
import "./index.css";
import AppBar from "./components/appbar/AppBar";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import BuildXChallengePopup from "./components/popup/BuildXChallengePopup";
import menuItems from "./routes/routes";
import "sweetalert2/dist/sweetalert2.min.css";

function App() {
  return (
    <BrowserRouter>
      <AppBar />
      <ScrollToTop />

      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {menuItems.map((item, index) => (
            <Route key={index} path={item.path} element={item.element} />
          ))}
        </Routes>
      </Suspense>

      <Footer />
      <BuildXChallengePopup />
    </BrowserRouter>
  );
}

export default App;
